import React from "react";
import Box from "@mui/material/Box";
import { Await, useLoaderData } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";

import { CMAddressBook, StatsResponse } from "services/apiService";
import CampaignForm, { CampaignFormActions } from "./CampaignForm";

const CreateCampaign = () => {
    const loaderData = useLoaderData() as {
        data: Promise<[StatsResponse, CMAddressBook[]]>;
    };

    return (
        // Loading indicator while fetching stats data
        <React.Suspense
            fallback={
                <Box
                    sx={{
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <CircularProgress />
                    <p>Loading STATS data...</p>
                </Box>
            }
        >
            <Await
                resolve={loaderData.data}
                errorElement={<p>Error while loading STATS data</p>}
            >
                <CampaignForm action={CampaignFormActions.CREATE} state={{ 'previous': 'create' }} />
            </Await>
        </React.Suspense>
    );
};

export default CreateCampaign;
